/**
 * Fursalogia — Central Brand Configuration
 *
 * Every visible brand string, headline, tagline, and public contact
 * point lives in ONE module so the brand can be tweaked without a
 * grep-across-40-files chore. Sprint 28a intermediate step toward the
 * full runtime Brand Management feature (Sprint B).
 *
 * When Sprint B lands, this file becomes the fallback / seed data
 * for the DB-backed `brand_settings` row consumed via BrandProvider.
 * Keep the export shape stable so the migration is a drop-in swap.
 *
 * Do NOT import lucide icons here — brand.mark stays a component
 * import at the consumer site so tree-shaking works.
 *
 * Sprint 31 — rebrand: Fursa → Fursalogia.
 * The Arabic common noun "فرصة" (= "opportunity") continues to be used
 * throughout body copy in its natural sense; only the *brand name*
 * moved to "فرصالوجيا" / "Fursalogia".
 */

const brand = Object.freeze({
  // Identity
  name:       "فرصالوجيا",
  latinName:  "Fursalogia",
  tagline:    "منصة استخبارات استثمار تنفيذية للمنطقة العربية",

  // Homepage hero copy
  hero: {
    eyebrow:  "INVESTMENT INTELLIGENCE",
    eyebrowAr:"منصّة استخبارات",
    headline: "في كل خبر اقتصادي فرصة استثمارية",
    support:  "نقرأ الأخبار الاقتصادية، ونستخرج منها الفرص، ثم نوثّقها بالأدلّة والمصادر قبل عرضها.",
  },

  // Footer copy
  footer: {
    description:
      "منصة استخبارات استثمار تنفيذية للمنطقة العربية. نحوّل الإشارات الاقتصادية إلى فرص مُقيَّمة، بمنهجية شفّافة وبيانات موثوقة.",
    betaLabel: "Beta · تحديث أسبوعي",
    tagline:   "Made in the region · للمستثمرين",
  },

  // Contact
  contact: {
    email: "contact@fursalogia.io",
    // If a helpdesk URL exists in future, wire it here.
    helpUrl: null,
  },

  // Legal
  legal: {
    privacyEffectiveDate: "2026-02-14",
    termsEffectiveDate:   "2026-02-14",
  },

  // Copyright
  copyright: (year) => `© ${year} فرصالوجيا · جميع الحقوق محفوظة.`,
});

export default brand;
